import * as React from "react";
import { createRoot } from "react-dom/client";
import App from "./js/App";
import * as serviceWorker from "./serviceWorker";
import swConfig from "./swConfig";

createRoot(document.getElementById("root")!).render(<App />);

serviceWorker.register(swConfig);
